export const TRANSFIX_PROVIDED_RATE_DESCRIPTION =
  'This is a Transfix rate. You will receive an invoice from Transfix when you book your LTL shipment at the Transfix rate. '
export const SHIPPER_PROVIDED_RATE_DESCRIPTION =
  'This is your rate from the carrier. You will receive an invoice from the carrier when you book your LTL shipment using this rate.'
